import gql from 'graphql-tag';

export const GET_DEFINED_TERMS_FOR_ORGANIZER = gql`
  query getAllDefinedTermsForOrganizer($assetShortName: String) {
    getAllDefinedTerms(assetShortName: $assetShortName) {
      _id
      assetShortName
      definedTerm
      documentCount
      createdAt
      ignore
    }
  }
`;

export const SET_DEFINED_TERM_IGNORE = gql`
  mutation setDefinedTermIgnore($id: String!, $ignore: Boolean!) {
    setDefinedTermIgnore(id: $id, ignore: $ignore) {
      isSucceeded
    }
  }
`;

export const GET_SIMILAR_DEFINED_TERMS = gql`
  query getSimilarDefinedTerms($assetShortName: String!, $definedTerm: String!, $limit: Float) {
    getSimilarDefinedTerms(assetShortName: $assetShortName, definedTerm: $definedTerm, limit: $limit) {
      _id
      definedTerm
      assetShortName
      score
      isSynonym
      isNotSynonym
    }
  }
`;

export const GET_SYNONYM_CLASSES = gql`
  query getSynonymClasses($assetShortName: String!) {
    getSynonymClasses(assetShortName: $assetShortName)
  }
`;

export const GET_ALL_SYNONYM_CLASSES = gql`
  query getAllSynonymClasses {
    getAllSynonymClasses {
      assetShortName
      synonymClasses
    }
  }
`;
